import { render, staticRenderFns } from "./comercio.mapa.vue?vue&type=template&id=1f0b1f37&scoped=true"
import script from "./comercio.mapa.vue?vue&type=script&lang=js"
export * from "./comercio.mapa.vue?vue&type=script&lang=js"
import style0 from "./comercio.mapa.vue?vue&type=style&index=0&id=1f0b1f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b1f37",
  null
  
)

export default component.exports